import { createFileRoute } from "@tanstack/react-router";
import { AgentGuardrailsCreateRoute } from "@/components/agents/agent-guardrails-route";

export const Route = createFileRoute(
	"/$owner/agents/$agentId/guardrails/create",
)({
	component: AgentGuardrailsCreatePage,
});

function AgentGuardrailsCreatePage() {
	const { owner, agentId } = Route.useParams();
	return <AgentGuardrailsCreateRoute owner={owner} agentId={agentId} />;
}
